"use es6";

import * as React from "react";
import { equal } from "apollo-stack-hubspot/internal/@wry/equality/lib/index";
export function useDeepMemo(memoFn, deps) {
  var ref = React.useRef();
  if (!ref.current || !equal(ref.current.deps, deps)) {
    ref.current = {
      value: memoFn(),
      deps: deps
    };
  }
  return ref.current.value;
}